import { $ } from '@situation/setdesign.util';

class EventCardData {
    constructor($el) {
        this.id = $el.data('filterId');
        const $title = $el.find('.content-listing-card__title a');
        this.title = $title.html();
        this.url = $title.attr('href');
        this.genre = $el.find('.content-listing-card__pretitle').text();
        this.img = $('<div class="fc-event__image"></div>');
        this.img.append($el.find('.content-listing-card__image').clone().addClass('fc-event__img'));
    }
}

export default EventCardData;
